import React from 'react';

import { css, cx } from '@emotion/css';
import { useTranslation } from 'react-i18next';

import { useStyles } from '@/hooks/useStyles.ts';
import { Theme } from '@/theme/CreateTheme.ts';
import { ControlledTextField } from '@/uiKit/molecules/ControlledTextField.tsx';

export type WeightFieldProps = {
  className?: string;
};

export const WeightField: React.FC<WeightFieldProps> = ({ className }) => {
  const styles = useStyles(makeStyles);
  const { t } = useTranslation();

  return (
    <div className={cx(styles.container, className)}>
      <ControlledTextField
        id="prescription-info-weight-input"
        name="weight"
        label={t('diabetesForms.weight')}
        variant="standard"
        type="number"
      />
    </div>
  );
};

const makeStyles = (theme: Theme) => ({
  container: css({
    maxWidth: theme.spacing(32),
  }),
});
